import Select from 'antd/es/select'

export const { Option, OptGroup } = Select

export default Select
